import React from 'react';
import PropTypes from 'prop-types';
import { Image } from 'react-bootstrap-5';
import IntegrationsModal from './integration_modal';

import twilioIcon from '../images/twilio.svg';
export default class CancelTwilioModal extends React.Component {

  static propTypes = {
    shown: PropTypes.bool,
    onCancel: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired
  };

  render() {
    const { shown, onCancel, onSave } = this.props;

    return (
      <IntegrationsModal
        disconnectModal
        shown={shown}
        title="Disconnect your Click-to-Call Phone Number"
        onCancel={onCancel}
        onSave={onSave}
      >
        <div className="text-center">
          <div className="mb-3">
            <div className="bg-body-tertiary border rounded p-2 d-inline-flex">
              <Image alt="Twilio integration" height={40} src={twilioIcon} width={40} />
            </div>
          </div>
          <span className="text-muted">
            You will need to verify your number again to use Buildout's Click-to-Call in the future.
          </span>
        </div>
      </IntegrationsModal>
    );
  }
}
